import axios from 'axios';

import { EVISIT_STATUS } from '../../../config/constants';

export const loadProviders = (providerId) =>
	axios.get(`/providers/${providerId}/get-pactice-provider-codes`);

export const createTextaVisit = (providerId, data) =>
	axios.post(`/providers/${providerId}/visit-text`, data);

export const isNumberMobile = async (providerId, number) => {
	try {
		const { data } = await axios.post(
			`/providers/${providerId}/twilio-lookup`,
			{ number }
		);
		if (data && ['mobile', 'voip'].includes(data.network_type)) {
			return { isTAVCapable: true };
		}
		return { isTAVCapable: false };
	} catch (err) {
		return { err };
	}
};

export const getOpenVisits = (practiceId) => {
	const where = {
		or: [
			{
				end_dttm: null,
				patientId: { neq: null },
				start_dttm: { neq: null },
				evisit_status: {
					inq: [
						EVISIT_STATUS.CREATED,
						EVISIT_STATUS.REOPENED,
						EVISIT_STATUS.IN_REVIEW,
						EVISIT_STATUS.IN_PROGRESS,
					],
				},
			},
			{
				end_dttm: null,
				patientId: { neq: null },
				evisit_status: {
					inq: [EVISIT_STATUS.SCHEDULED, EVISIT_STATUS.SCHEDULED_PENDING],
				},
			},
		],
	};
	const filter = JSON.stringify({
		where,
		order: ['start_dttm ASC'],
		include: [
			{
				relation: 'patient',
				scope: {
					include: [
						{
							relation: 'insurances',
							scope: {
								limit: 1,
								order: ['id DESC'],
							},
						},
					],
				},
			},
			'provider',
			'patient_dependent',
			'provider_visit_type',
			'care_quest_response_groups',
			{
				relation: 'evisit_provider_transactions',
				scope: {
					limit: 5,
					order: 'update_dttm DESC',
					include: 'provider',
				},
			},
			{
				'evisit-referral': {
					'closedBy-provider': 'provider_practice',
				},
			},
			{
				relation: 'appointment_schedule',
				scope: {
					where: {
						scheduled_start_dttm: { neq: null },
					},
				},
			},
		],
	});
	return axios.get(`/provider_practices/${practiceId}/evisits`, {
		params: { filter },
	});
};
